interface Props {
  title: string;
  message: string;
  className?: string;
}

export function NoTasksAlert({ title, message, className }: Props) {
  return (
    <div className={`flex justify-center ${className ?? ''}`}>
      <div className="w-4/5 flex flex-col items-center justify-center text-center h-48 rounded-lg bg-feedback-success/10 border border-feedback-success/20 p-6">
        <svg className="w-10 h-10 text-feedback-success mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className="text-xl font-bold mb-2">{title}</p>
        <p className="text-sm text-text-secondary">{message}</p>
      </div>
    </div>
  );
}
